import { useFieldContext, FieldErrors } from '..';
import { RadioGroupV2, RadioGroupV2Props } from '../../Elements';

export type RadioFieldProps = Omit<RadioGroupV2Props, 'name' | 'value' | 'onValueChange'>;

export function RadioField<TValue extends string = string>({ ...groupProps }: RadioFieldProps) {
	const field = useFieldContext<string>();

	// hide the error messages until the field has been touched
	const hideErrors = !field.state.meta.isTouched;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<RadioGroupV2
				{...groupProps}
				name={field.name}
				value={field.state.value}
				onValueChange={(value) => field.handleChange(value as TValue)}
				aria-invalid={hasErrors ? 'true' : 'false'}
				aria-errormessage={hasErrors ? `${field.name}-error` : ''}
			/>
			<FieldErrors name={field.name} meta={field.state.meta} hideErrors={hideErrors} />
		</>
	);
}
